
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info-terkini",
      function () {
        return require("private-next-pages/info-terkini/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info-terkini"])
      });
    }
  